export const GET_ALL_DATA_SETS = 'GET:ALL:DATA:SETS';
export const GET_DATA_SETS_WITH_PAGINATION = 'GET:DATA:SETS:WITH:PAGINATION';
export const UPDATE_DATA_SET = 'UPDATE:DATA:SET';
export const UPDATE_ALL_DATA_SETS = 'UPDATE:ALL:DATA:SETS';
export const SEARCH_DATA_SETS = 'SEARCH:DATA:SETS';
export const CLEAR_DATA_SETS = 'CLEAR:DATA:SETS';
